import { useCallback, useSyncExternalStore } from 'react';
import type { MediaResolver, Variant } from '../editor/lod';

const noSubscribe = () => () => undefined;

/** URL of one variant of an asset ('' until known), re-rendering when the resolver learns it. */
export function useAssetUrl(media: MediaResolver, assetId: string | null, variant: Variant): string {
  const subscribe = useCallback((cb: () => void) => media.subscribe?.(cb) ?? noSubscribe(), [media]);
  return useSyncExternalStore(subscribe, () => (assetId ? media.urlFor(assetId, variant) : ''));
}
